// ─── Utilitaires date/heure partagés — Core ──────────────────────
// Centralise les helpers redéfinis dans de nombreux écrans (fmtFR, pad,
// dateKey, parse, décalage…). Convention : « iso » = chaîne 'AAAA-MM-JJ'.
// Les mois passés en paramètre numérique sont 0-indexés (comme Date.getMonth()).

export const pad2 = (n) => String(n).padStart(2, '0');

// Date → 'AAAA-MM-JJ' (heure locale).
export const isoDeDate = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;

// 'AAAA-MM-JJ' → Date (minuit local).
export const dateDeIso = (s) => { const [y, m, d] = String(s || '').split('-').map(Number); return new Date(y || 1970, (m || 1) - 1, d || 1); };

// (année, mois 0-indexé, jour) → 'AAAA-MM-JJ'. Équivaut à l'ancien dateKey().
export const isoDeYMD = (an, mo, jour) => `${an}-${pad2(mo + 1)}-${pad2(jour)}`;

// Décale une date-clé de n jours (peut être négatif).
export const decalerIso = (s, n) => { const d = dateDeIso(s); d.setDate(d.getDate() + n); return isoDeDate(d); };

// Formats français d'affichage.
export const frJMA = (s) => { if (!s) return ''; const [y, m, d] = String(s).split('-'); return `${d}/${m}/${y}`; };        // JJ/MM/AAAA
export const frJM = (s) => { if (!s) return ''; const [y, m, d] = String(s).split('-'); return `${d}/${m}`; };             // JJ/MM
export const frJMAcourt = (s) => { if (!s) return ''; const [y, m, d] = String(s).split('-'); return `${d}/${m}/${(y || '').slice(2)}`; };  // JJ/MM/AA

// N° de semaine ISO 8601 (semaine du lundi ; la semaine 1 contient le 1er jeudi).
export function numeroSemaineISO(date) {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const jour = (d.getUTCDay() + 6) % 7;                 // lundi = 0 … dimanche = 6
  d.setUTCDate(d.getUTCDate() - jour + 3);              // jeudi de la semaine ISO
  const premierJeudi = new Date(Date.UTC(d.getUTCFullYear(), 0, 4));
  const fj = (premierJeudi.getUTCDay() + 6) % 7;
  premierJeudi.setUTCDate(premierJeudi.getUTCDate() - fj + 3);
  return 1 + Math.round((d - premierJeudi) / 604800000);
}

// ── Minutes ↔ « HH:MM » (source unique — remplace les _h/_mmHH locaux) ──
export const minutesDeHHMM = (x) => { const [h, m] = String(x || '').split(':').map(Number); return (h || 0) * 60 + (m || 0); };
export const hhmmDeMinutes = (m) => `${String(Math.floor(m / 60)).padStart(2, '0')}:${String(Math.round(m % 60)).padStart(2, '0')}`;
